import { useId, type ReactNode } from 'react';
import {Icon} from './Icon';

export type SaveResultKind='success'|'partial'|'error';

export type SaveResultProps=Readonly<{
  kind:SaveResultKind;
  title:string;
  message:ReactNode;
  details?:ReactNode;
  actions?:ReactNode;
  className?:string;
}>;

export function SaveResult({kind,title,message,details,actions,className}:SaveResultProps){
  const titleId=useId();
  const messageId=useId();
  const classes=['save-result',`save-result--${kind}`,className].filter(Boolean).join(' ');
  return <section
    className={classes}
    data-result={kind}
    role={kind==='error'?'alert':'status'}
    aria-live={kind==='error'?'assertive':'polite'}
    aria-atomic="true"
    aria-labelledby={titleId}
    aria-describedby={messageId}
  >
    <span className="save-result__symbol" aria-hidden="true"><Icon name={kind==='success'?'circle-check':'circle-alert'}/></span>
    <div className="save-result__copy">
      <h2 id={titleId}>{title}</h2>
      <div id={messageId} className="save-result__message">{message}</div>
      {details&&<div className="save-result__details">{details}</div>}
    </div>
    {actions&&<div className="save-result__actions">{actions}</div>}
  </section>;
}
